// Shared Fieldbook footer. Render inside a `.ffly .ffly--public` (full) or
// `.ffly .ffly--app` (compact) wrapper — tokens cascade from there.
import "@/styles/design-tokens.css";
import "./field-chrome.css";

const YEAR = new Date().getFullYear();

export default function FieldFooter({ variant = "full" }: { variant?: "full" | "compact" }) {
  if (variant === "compact") {
    return (
      <div className="ffly-ftr-wrap">
        <div className="ffly-ftr--compact">
          <span>© {YEAR} FHIRfly.io LLC. All rights reserved.</span>
          <nav>
            <a href="/docs">Docs</a>
            <a href="/status">Status</a>
            <a href="/docs/legal/terms">Terms</a>
            <a href="/docs/legal/privacy">Privacy</a>
          </nav>
        </div>
      </div>
    );
  }
  return (
    <div className="ffly-ftr-wrap">
      <footer className="ffly-ftr">
        <div className="col brandcol">
          <img className="logo" src="/logo-horiz-color-transparent.png" alt="FHIRfly" />
          <p>Healthcare terminology, enriched. Names humans read, from official registries.</p>
        </div>
        <div className="col">
          <h4>Tools</h4>
          <a href="/tools/npi-lookup">NPI Lookup</a>
          <a href="/tools">API Playground</a>
          <a href="/claims-calculator">Claims Calculator</a>
        </div>
        <div className="col">
          <h4>Developers</h4>
          <a href="/docs">Docs</a>
          <a href="/pricing">Pricing</a>
          <a href="/status">Status</a>
        </div>
        <div className="col">
          <h4>Legal</h4>
          <a href="/docs/legal/terms">Terms</a>
          <a href="/docs/legal/privacy">Privacy</a>
          <a href="/docs/legal/data-sources">Data Sources</a>
        </div>
      </footer>
      <div className="ffly-ftr-bar">© {YEAR} FHIRfly.io LLC. All rights reserved. · Terminology data sourced from official registries, updated daily.</div>
    </div>
  );
}
